// extracted by mini-css-extract-plugin
export var linkText = "_o0-0";